import { AIRDROP_FARMING_EXCHANGE_CONFIG, HIP3_PLATFORMS, isHip3Platform } from "@/constants/airdrop-farming";
import type { AirdropFarmingExchangeConfig } from "@/constants/airdrop-farming";

/**
 * Resolve exchange config -- falls back to HIP-3 platform info when
 * the exchangeId is a HIP-3 ID (e.g. "flx").
 */
export function resolveExchangeConfig(exchangeId: string): Partial<AirdropFarmingExchangeConfig> | undefined {
  const directConfig = AIRDROP_FARMING_EXCHANGE_CONFIG[exchangeId as keyof typeof AIRDROP_FARMING_EXCHANGE_CONFIG];
  if (directConfig) return directConfig;

  if (isHip3Platform(exchangeId)) {
    const platform = HIP3_PLATFORMS[exchangeId];
    return {
      name: platform.label,
      label: platform.label,
      sublabel: "HIP-3",
      icon: "hyperliquid",
      accountLabel: "Hyperliquid Account",
    };
  }

  return undefined;
}

/**
 * Returns the human-readable exchange name for a given exchange ID.
 * Used by DnBotRow for display in stat rows.
 */
export function getExchangeDisplayName(exchangeId: string): string {
  if (isHip3Platform(exchangeId)) {
    return HIP3_PLATFORMS[exchangeId].label;
  }
  const config = AIRDROP_FARMING_EXCHANGE_CONFIG[exchangeId as keyof typeof AIRDROP_FARMING_EXCHANGE_CONFIG];
  return config?.label ?? exchangeId;
}
